<template>
    <card>
        <div class="row align-items-center" v-if="compact">
            <div class="col">

                <learners-info :registration="registration"
                    :simulation="simulation"
                    :session="session"
                    :compact="compact">
                </learners-info>

            </div>
            <div class="col-auto">

                <learners-cohort :registration="registration"
                    :groups="groups"
                    :compact="compact"
                    @openCohort="$emit('openCohort')"
                    @openGroup="$emit('openGroup')">
                </learners-cohort>

            </div>
        </div>

        <learners-info v-if="!compact"
            :registration="registration"
            :simulation="simulation"
            :session="session"
            :compact="compact">
        </learners-info>

        <learners-cohort v-if="!compact"
            :registration="registration"
            :groups="groups"
            :compact="compact"
            @openCohort="$emit('openCohort')"
            @openGroup="$emit('openGroup')">
        </learners-cohort>

    </card>
</template>

<script>
    import User from '../../dashboard/common/User'
    import LearnersInfo from './LearnersInfo'
    import LearnersCohort from './LearnersCohort'

    export default {

        components: {
            User, LearnersInfo, LearnersCohort
        },
        
        props: {

            registration: {
                type: Object,
                required: true
            },
            
            simulation: {
                type: Object,
                required: true
            },
            
            session: {
                type: Object,
                required: true
            },

            groups: {
                type: Array,
                default: null
            },

            compact: {
                type: Boolean,
                default: false
            },
        },
    }
</script>
